/* tslint:disable */
/* eslint-disable */
/**
 * ${api_name}
 * The Ciptex Race Notified Booking API is for use from [Ciptex Race](https://ciptex.com/race), [Twilio Flex](https://www.twilio.com/flex) and [Twilio Studio](https://www.twilio.com/studio)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AccountFromJSON, AccountToJSON, } from './Account';
import { OptionsFromJSON, OptionsToJSON, } from './Options';
import { MetaDataFromJSON, MetaDataToJSON, } from './MetaData';
import { BookingDetailCallbacksFromJSON, BookingDetailCallbacksToJSON, } from './BookingDetailCallbacks';
import { EventFromJSON, EventToJSON, } from './Event';
import { BookingStatusFromJSON, BookingStatusToJSON, } from './BookingStatus';
import { BrandingFromJSON, BrandingToJSON, } from './Branding';
import { RegistrationFieldFromJSON, RegistrationFieldToJSON, } from './RegistrationField';
import { ContactFromJSON, ContactToJSON, } from './Contact';
import { DialInGroupFromJSON, DialInGroupToJSON, } from './DialInGroup';
/**
 * Check if a given object implements the BookingItem interface.
 */
export function instanceOfBookingItem(value) {
    if (!('accountSid' in value) || value['accountSid'] === undefined)
        return false;
    if (!('bookingId' in value) || value['bookingId'] === undefined)
        return false;
    if (!('event' in value) || value['event'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('callbacks' in value) || value['callbacks'] === undefined)
        return false;
    return true;
}
export function BookingItemFromJSON(json) {
    return BookingItemFromJSONTyped(json, false);
}
export function BookingItemFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'accountSid': json['accountSid'],
        'bookingId': json['bookingId'],
        'event': EventFromJSON(json['event']),
        'account': json['account'] == null ? undefined : AccountFromJSON(json['account']),
        'status': BookingStatusFromJSON(json['status']),
        'branding': json['branding'] == null ? undefined : BrandingFromJSON(json['branding']),
        'assignedHosts': json['assignedHosts'] == null ? undefined : json['assignedHosts'],
        'dialInGroups': json['dialInGroups'] == null ? undefined : (json['dialInGroups'].map(DialInGroupFromJSON)),
        'options': json['options'] == null ? undefined : OptionsFromJSON(json['options']),
        'leader': json['leader'] == null ? undefined : ContactFromJSON(json['leader']),
        'organizer': json['organizer'] == null ? undefined : ContactFromJSON(json['organizer']),
        'notes': json['notes'] == null ? undefined : json['notes'],
        'registrationFields': json['registrationFields'] == null ? undefined : (json['registrationFields'].map(RegistrationFieldFromJSON)),
        'registrationForwardingUrl': json['registrationForwardingUrl'] == null ? undefined : json['registrationForwardingUrl'],
        'callbacks': BookingDetailCallbacksFromJSON(json['callbacks']),
        'meta': json['meta'] == null ? undefined : MetaDataFromJSON(json['meta']),
    };
}
export function BookingItemToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'accountSid': value['accountSid'],
        'event': EventToJSON(value['event']),
        'account': AccountToJSON(value['account']),
        'status': BookingStatusToJSON(value['status']),
        'branding': BrandingToJSON(value['branding']),
        'assignedHosts': value['assignedHosts'],
        'dialInGroups': value['dialInGroups'] == null ? undefined : (value['dialInGroups'].map(DialInGroupToJSON)),
        'options': OptionsToJSON(value['options']),
        'leader': ContactToJSON(value['leader']),
        'organizer': ContactToJSON(value['organizer']),
        'notes': value['notes'],
        'registrationFields': value['registrationFields'] == null ? undefined : (value['registrationFields'].map(RegistrationFieldToJSON)),
        'registrationForwardingUrl': value['registrationForwardingUrl'],
        'callbacks': BookingDetailCallbacksToJSON(value['callbacks']),
        'meta': MetaDataToJSON(value['meta']),
    };
}
